import { useCallback } from 'react';
import { useChatInputStore, useModalStore, useAuthStore } from '@/store';

export default function useNewChatBotPicker({ selectedBot, isWorkMode = false } = {}) {
  const openModal = useModalStore(state => state.actions.openModal);
  const label = selectedBot ? `Change bot, currently ${selectedBot.name}` : isWorkMode ? 'Choose a bot' : 'Chat with a bot';

  const selectBot = useCallback((bot) => {
    if (bot?.flags?.isPlusOnly && !useAuthStore.getState().user?.flags?.isPlus) {
      openModal('PlusFeatureModal', { feature: 'bots' });
      return false;
    }
    // Select in place: keep the draft, attachments, model and Chat/Work mode.
    const composer = useChatInputStore.getState();
    composer.setContext('new');
    composer.setSelectedAgents(bot ? [bot.id] : [], { botId: bot?.id || null });
    return true;
  }, [openModal]);

  const openBotPicker = useCallback(() => {
    openModal('BotPickerModal', { onSelect: selectBot, isWorkMode });
  }, [openModal, selectBot, isWorkMode]);

  return { label, openBotPicker };
}
